import type { Resource } from '@efdigital/ll-addon-data';
import type { TOC } from '@ember/component/template-only';

interface ResourceThumbnailSignature {
  Args: {
    resource: Resource | null;
    /**
     * Fill a horizontal card column instead of a 16:9 box. Used on the
     * shared list so the cover matches the body height.
     */
    stretch?: boolean;
    /** Prefer the full cover image over the low-res listing thumbnail. */
    preferFullImage?: boolean;
  };
  Element: HTMLDivElement;
}

/**
 * Cover image for a published resource. Same source as admin/CMS listings
 * (`icon`, then `image`). Empty alt: the title always sits beside the image.
 */
export function resourceThumbnailUrl(
  resource: Resource | null | undefined,
  preferFullImage = false
): string | null {
  if (!resource) {
    return null;
  }
  const url = preferFullImage
    ? resource.image || resource.icon
    : resource.icon || resource.image;
  return url || null;
}

const ResourceThumbnail: TOC<ResourceThumbnailSignature> = <template>
  <div
    class="bg-body-secondary
      {{if @stretch 'll-shared-resource-cover' 'ratio ratio-16x9'}}"
    ...attributes
  >
    {{#let (resourceThumbnailUrl @resource @preferFullImage) as |src|}}
      {{#if src}}
        <img src={{src}} alt="" class="object-fit-cover" />
      {{else}}
        <div
          class="d-flex align-items-center justify-content-center"
          aria-hidden="true"
        >
          <iconify-icon icon="ph:books" class="fs-1 text-body-secondary" />
        </div>
      {{/if}}
    {{/let}}
  </div>
</template>;

export default ResourceThumbnail;
